module.exports = __webpack_public_path__ + "static/img/astral.1fb5813.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/astral.png
// module id = k0Lx
// module chunks = 1